import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
// This is a generic dropdown controller for any dropdown in the application
export default class extends Controller {
  static targets = ["menu", "button"]
  static values = {
    open: { type: Boolean, default: false }
  }

  connect() {
    document.addEventListener('click', this.outsideClickHandler)
  }

  disconnect() {
    document.removeEventListener('click', this.outsideClickHandler)
  }

  toggle() {
    this.openValue = !this.openValue
  }

  hide() {
    this.openValue = false
  }

  openValueChanged() {
    if (this.openValue) {
      this.menuTarget.classList.remove('hidden')
    } else {
      this.menuTarget.classList.add('hidden')
    }
  }

  // Handler for clicks outside the dropdown
  outsideClickHandler = (event) => {
    if (this.openValue && !this.element.contains(event.target)) {
      this.hide()
    }
  }
}
